/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBrowserAbandon = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14 19v2H7v-2zm6.293-4.707 1.414 1.414L20.415 17l1.292 1.293-1.414 1.414L19 18.415l-1.293 1.292-1.414-1.414L17.585 17l-1.292-1.293 1.414-1.414L19 15.585zM22 3v9h-2V5H4v11h10v2H2V3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBrowserAbandon as BrowserAbandon };
